import { pageHead, unavailableHead, hasUnavailableMatch } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import Cookies from "@/pages/Cookies";

export const Route = createFileRoute("/_public/cookies")({
  head: ({ matches }) => hasUnavailableMatch(matches) ? unavailableHead() : pageHead("Cookie Policy \u2014 Modern Fence Install", "How Modern Fence Install LLC uses cookies and similar technologies on modernfenceinstall.com.", "/cookies", false),
  component: Cookies,
});
